const app = {
  state: {
    project: {},
    orgTypes: [{ label: '社会团体' }, { label: '民办非企业' }, { label: '企业' }, { label: '基金会' }],
    nationalities: [{ label: '中国大陆籍' }, { label: '非中国大陆籍' }],
    memberDuties: [{ label: '机构领导人' }, { label: '项目官员' }, { label: '财务负责人' }, { label: '项目报告人' }],
    recipientTypes: [
      { label: '失亲孤儿' },
      { label: '事实孤儿' },
      { label: '困难儿童' },
      { label: '留守儿童' },
      { label: '乡村儿童' },
      { label: '疾病患儿' },
      { label: '寒门学子' },
      { label: '孤寡老人' },
      { label: '抗战老兵' },
      { label: '失能老人' },
      { label: '困境女性' },
      { label: '流浪动物' },
      { label: '苦难家庭' },
      { label: '农民兄弟' },
      { label: '少数民族' },
      { label: '社会服务者' },
      { label: '困境女童' },
      { label: '野生动物' },
      { label: '濒危动物' },
      { label: '残障人士' },
      { label: '受灾民众' },
      { label: '志愿者' },
      { label: '自然环境' },
    ],
  },
  mutations: {
    setProject(state, data) {
      state.project = data || {}
    },
  },
  actions: {
    setProject({ commit }, options) {
      commit('setProject', options)
    },
  },
}

export default app
